/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseOrdersDto as DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrdersDto } from '../../models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/purchase-orders-dto';

export interface GetPurchaseOrders$Params {
  inventoryId: string;
  searchTerm?: string;
}

export function getPurchaseOrders(http: HttpClient, rootUrl: string, params: GetPurchaseOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrdersDto>> {
  const rb = new RequestBuilder(rootUrl, getPurchaseOrders.PATH, 'get');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.query('searchTerm', params.searchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrdersDto>;
    })
  );
}

getPurchaseOrders.PATH = '/api/inventories/{inventoryId}/purchase-orders';
